<template>
	<PageContainer>
		<v-row>
			<v-col cols="12">
				<!-- Section "Exécutant PS" -->
				<AmeliproCard card-title="Exécutant PS">
					<div v-if="executant && null != garde.executant">
						<v-row>
							<v-col
								cols="12"
								md="4"
							>
								<v-list-item>
									<v-list-item-content>
										<v-list-item-title>Nom</v-list-item-title>
										<v-list-item-subtitle>
											{{ executant.denominationComplet }}
										</v-list-item-subtitle>
									</v-list-item-content>
								</v-list-item>
							</v-col>
							<v-col
								cols="12"
								md="4"
							>
								<v-list-item>
									<v-list-item-content>
										<v-list-item-title>N°</v-list-item-title>
										<v-list-item-subtitle>
											{{ executant.numeroPrint }}
										</v-list-item-subtitle>
									</v-list-item-content>
								</v-list-item>
							</v-col>
							<v-col
								cols="12"
								md="4"
							>
								<v-list-item v-if="executant.isStructure">
									<v-list-item-content>
										<v-list-item-title>N° FINESS</v-list-item-title>
										<v-list-item-subtitle>
											{{ executant.finess }}
										</v-list-item-subtitle>
									</v-list-item-content>
								</v-list-item>
								<v-list-item v-if="executant.organisme">
									<v-list-item-content>
										<v-list-item-title>
											Organisme de rattachement
										</v-list-item-title>
										<v-list-item-subtitle>
											{{ executant.organisme.libelleComplet }}
										</v-list-item-subtitle>
									</v-list-item-content>
								</v-list-item>
							</v-col>
						</v-row>
					</div>
					<div v-else>
						<p>Aucune information disponible</p>
					</div>
				</AmeliproCard>
			</v-col>

			<v-col cols="12">
				<!-- Section "Garde" -->
				<AmeliproCard card-title="Garde">
					<v-row>
						<v-col
							cols="12"
							md="4"
						>
							<v-list-item>
								<v-list-item-content>
									<v-list-item-title>Date heure de début</v-list-item-title>
									<v-list-item-subtitle>
										{{ gardeRecue.afficherDateDebut }}
									</v-list-item-subtitle>
								</v-list-item-content>
							</v-list-item>
							<v-list-item>
								<v-list-item-content>
									<v-list-item-title>Date heure de fin</v-list-item-title>
									<v-list-item-subtitle>
										{{ gardeRecue.afficherDateFin }}
									</v-list-item-subtitle>
								</v-list-item-content>
							</v-list-item>
							<v-list-item>
								<v-list-item-content>
									<v-list-item-title>Nombre d'heures</v-list-item-title>
									<v-list-item-subtitle>
										{{ gardeRecue.nombreHeure }}
									</v-list-item-subtitle>
								</v-list-item-content>
							</v-list-item>

							<v-list-item v-if="gardeRecue.numeroRemplacant">
								<v-list-item-content>
									<v-list-item-title>N° du remplaçant </v-list-item-title>
									<v-list-item-subtitle>
										{{ gardeRecue.numeroRemplacant }}
									</v-list-item-subtitle>
								</v-list-item-content>
							</v-list-item>
							<v-list-item v-else>
								<v-list-item-title>Pas de remplacement</v-list-item-title>
							</v-list-item>
						</v-col>
						<v-col
							cols="12"
							md="4"
						>
							<v-list-item>
								<v-list-item-content>
									<v-list-item-title>N° AM paiement</v-list-item-title>
									<v-list-item-subtitle>
										{{ garde.numeroPaiement }}
									</v-list-item-subtitle>
								</v-list-item-content>
							</v-list-item>
							<v-list-item v-if="gardeRecue.montant">
								<v-list-item-content>
									<v-list-item-title>Montant </v-list-item-title>
									<v-list-item-subtitle>
										{{ gardeRecue.montant }} €
									</v-list-item-subtitle>
								</v-list-item-content>
							</v-list-item>
							<v-list-item>
								<v-list-item-content>
									<v-list-item-title>Statut </v-list-item-title>
									<v-list-item-subtitle>
										{{ garde.statutLibelleFront }}
									</v-list-item-subtitle>
								</v-list-item-content>
							</v-list-item>
							<v-list-item>
								<v-list-item-content>
									<v-list-item-title>Secteur </v-list-item-title>
									<v-list-item-subtitle>
										{{ gardeRecue.secteur }}
									</v-list-item-subtitle>
								</v-list-item-content>
							</v-list-item>
						</v-col>
						<v-col
							cols="12"
							md="4"
						>
							<v-list-item>
								<v-list-item-content>
									<v-list-item-title>Code acte </v-list-item-title>
									<v-list-item-subtitle>
										{{ gardeRecue.codeActe }}
									</v-list-item-subtitle>
								</v-list-item-content>
							</v-list-item>
							<v-list-item>
								<v-list-item-content>
									<v-list-item-title>Type de PDS</v-list-item-title>
									<v-list-item-subtitle>
										{{ gardeRecue.lot.typePdsLibelle }}
									</v-list-item-subtitle>
								</v-list-item-content>
							</v-list-item>
						</v-col>
					</v-row>
				</AmeliproCard>
			</v-col>
		</v-row>
		<v-row>
			<v-col
				v-if="delegataire"
				cols="12"
			>
				<!-- Section "Mandataire" -->
				<AmeliproCard card-title="Mandataire">
					<v-list-item>
						<v-list-item-content>
							<v-list-item-title>Dénomination</v-list-item-title>
							<v-list-item-subtitle>
								{{ delegataire.denominationComplet }}
							</v-list-item-subtitle>
						</v-list-item-content>
					</v-list-item>
					<v-list-item>
						<v-list-item-content>
							<v-list-item-title>Identifiant du mandataire</v-list-item-title>
							<v-list-item-subtitle>
								{{ delegataire.numeroPrint }}
							</v-list-item-subtitle>
						</v-list-item-content>
					</v-list-item>
					<v-list-item>
						<v-list-item-content>
							<v-list-item-title>
								Est destinataire de paiement
							</v-list-item-title>
							<v-list-item-subtitle>
								{{ garde.isMandataire ? 'oui' : 'non' }}
							</v-list-item-subtitle>
						</v-list-item-content>
					</v-list-item>
				</AmeliproCard>
			</v-col>

			<v-col cols="12">
				<AmeliproCard card-title="Réception / Lot">
					<v-row>
						<v-col
							cols="12"
							md="4"
						>
							<v-list-item v-if="lot.lgg">
								<v-list-item-content>
									<v-list-item-title>Émetteur </v-list-item-title>
									<v-list-item-subtitle>
										{{ lot.lgg.emetteur }}
									</v-list-item-subtitle>
								</v-list-item-content>
							</v-list-item>
							<v-list-item>
								<v-list-item-content>
									<v-list-item-title>
										Identifiant garde dans le lot
									</v-list-item-title>
									<v-list-item-subtitle>
										{{ gardeRecue.numero }}
									</v-list-item-subtitle>
								</v-list-item-content>
							</v-list-item>
							<v-list-item>
								<v-list-item-content>
									<v-list-item-title>Type de PDS</v-list-item-title>
									<v-list-item-subtitle>
										{{ lot.typePdsLibelle }}
									</v-list-item-subtitle>
								</v-list-item-content>
							</v-list-item>
						</v-col>
						<v-col
							cols="12"
							md="4"
						>
							<v-list-item>
								<v-list-item-content>
									<v-list-item-title>Département</v-list-item-title>
									<v-list-item-subtitle>
										{{ lot.departement.libelleComplet }}
									</v-list-item-subtitle>
								</v-list-item-content>
							</v-list-item>
							<v-list-item>
								<v-list-item-content>
									<v-list-item-title>Mois concerné</v-list-item-title>
									<v-list-item-subtitle>
										{{ lot.moisConcerne }}
									</v-list-item-subtitle>
								</v-list-item-content>
							</v-list-item>
							<v-list-item>
								<v-list-item-content>
									<v-list-item-title>Date d'import du lot</v-list-item-title>
									<v-list-item-subtitle>
										{{ formattedDateValidation }}
									</v-list-item-subtitle>
								</v-list-item-content>
							</v-list-item>
						</v-col>
						<v-col
							cols="12"
							md="4"
						>
							<v-list-item>
								<v-list-item-content>
									<v-list-item-title>N° d'ordre :</v-list-item-title>
									<v-list-item-subtitle>
										{{ lot.numeroOrdre }}
									</v-list-item-subtitle>
								</v-list-item-content>
							</v-list-item>
						</v-col>
					</v-row>
				</AmeliproCard>
			</v-col>
		</v-row>
		<v-row>
			<v-col cols="12">
				<AmeliproCard card-title="Historique">
					<AmeliproTable
						id="detail-historique"
						title="Détails"
						:headers="headers"
						:data-list="historiqueGardes"
						no-table-infos
					>
						<template #item-date-heure="row">
							<strong>
								{{ row.dateHeure }}
							</strong>
						</template>
					</AmeliproTable>
				</AmeliproCard>
			</v-col>
		</v-row>
	</PageContainer>
</template>

<script lang="ts">
	import Vue from 'vue';
	import Component from 'vue-class-component';
	import {
		Garde,
		GardeRecue,
		Executant,
		Delegataire,
		Lot,
		HistoriqueGarde
	} from '@/services/api/types';
	import { formatDateTime } from '@/services/dateFormatter';

	@Component<DetailGarde>({
		props: {
			garde: {
				type: Object,
				required: true
			}
		}
	})
	export default class DetailGarde extends Vue {
		garde!: Garde;
		gardeRecue!: GardeRecue;
		executant!: Executant;
		delegataire!: Delegataire;
		lot!: Lot;
		historiqueGardes: HistoriqueGarde[] = [];

		headers = [
			{
				name: 'date-heure',
				title: 'Date',
				minWidth: '20%',
				width: '25%',
				maxWidth: '25%',
				align: 'left'
			},
			{
				name: 'statutLibelleFront',
				title: 'Action',
				minWidth: '20%',
				width: '25%',
				maxWidth: '25%',
				align: 'left'
			},
			{
				name: 'quiLibelleCompletFront',
				title: 'Auteur',
				minWidth: '20%',
				width: '25%',
				maxWidth: '25%',
				align: 'left'
			}
		];

		created() {
			this.gardeRecue = this.garde.gardeRecue;
			this.executant = this.garde.executant;
			this.delegataire = this.garde.delegataire;
			this.lot = this.gardeRecue.lot;
			this.historiqueGardes = this.garde.historiquesUtilisateurExterne;
		}

		get executantisStructure(): boolean {
			if ('numAmActuelStructure' in this.executant) {
				return true;
			}
			return false;
		}

		get formattedDateValidation(): string {
			return this.garde.gardeRecue.dateReception
				? formatDateTime(this.garde.gardeRecue.dateReception)
				: '';
		}
	}
</script>
